import React from 'react';
import { Card, Empty } from 'antd';
import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area } from 'recharts';
import moment from 'moment';

const UserConnectedChart = ({ data }) => {
  const allZero = !data.some(d => d.total > 0);
  let yMax = 10;
  if (!allZero) {
    const maxVal = Math.max(...data.map(d => Number(d.total) || 0));
    if (maxVal < 100) yMax = Math.max(Math.ceil(maxVal / 10) * 10, 10);
    else if (maxVal <= 1000) yMax = Math.ceil(maxVal / 100) * 100;
    else if (maxVal <= 10000) yMax = Math.ceil(maxVal / 1000) * 1000;
    else yMax = Math.ceil(maxVal / 10000) * 10000;
  }
  const formatDate = dateStr => {
    const date = moment(dateStr);
    const day = date.date();
    return day % 5 === 0 || day === date.daysInMonth() ? day.toString() : '';
  };
  return (
    <Card className="side-panel align-center" style={{ minHeight: '500px' }}>
      {!allZero ? (
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 20, right: 30, left: 40, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="date" tickFormatter={formatDate} interval={0} tick={{ fontSize: 12 }} label={{ value: 'Date', position: 'insideBottom', offset: -10 }} />
            <YAxis domain={[0, yMax]} tickFormatter={v => v >= 1000 ? `${v/1000}k` : v} tick={{ fontSize: 12 }} label={{ value: 'Total Users', angle: -90, position: 'insideLeft', offset: 10 }} width={60} />
            <Tooltip formatter={value => [value >= 1000 ? `${(value/1000).toFixed(1)}k` : value, 'Total Users']} labelFormatter={date => moment(date).format('MMM D')} />
            <Area type="monotone" dataKey="total" stroke="#8884d8" fill="#8884d8" fillOpacity={0.3} dot={{ r: 4 }} activeDot={{ r: 6 }} />
          </AreaChart>
        </ResponsiveContainer>
      ) : <Empty />}
    </Card>
  );
};

export default UserConnectedChart;